<template>
    <ul class="c-pagination text-center">

        <li :class="{ 'c-pagination__disabled': current == 1 }">
            <button :disabled="current == 1" @click="$emit('select', current +-1)">
                <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M13.8286 19a.9982.9982 0 0 1-.78-.373l-4.828-6c-.298-.371-.294-.901.011-1.267l5-6c.353-.424.984-.481 1.409-.128.424.353.481.984.127 1.408l-4.475 5.371 4.315 5.362c.346.43.278 1.06-.153 1.406a.9917.9917 0 0 1-.626.221" id="arrow-left"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#arrow-left"/></svg>
            </button>
        </li>

        <li v-for="(n, index) in buttons" :key="index">
            <button v-if="n == '.'" disabled>...</button>
            <button v-else :disabled="current == n" :class="{'c-pagination__current' : current === n}" @click="$emit('select', n)" >{{n}}</button>
        </li>

        <li :class="{ 'c-pagination__disabled': current == pages }">
            <button :disabled="current == pages" @click="$emit('select', current + 1)">
                <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9.9995 19a.9954.9954 0 0 1-.64-.232c-.424-.353-.481-.984-.128-1.408l4.476-5.371-4.315-5.362c-.346-.43-.278-1.06.152-1.406.431-.346 1.06-.278 1.407.152l4.828 6c.298.371.294.901-.011 1.267l-5 6a.9993.9993 0 0 1-.769.36" id="arrow-right"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#arrow-right"/></svg>
            </button>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        pages: {
            type: Number,
            required: true
        },
        current: {
            type: Number,
            required: true
        }
    },
    computed: {

        buttons() {

            let buttons = [];

            if ( this.current < 5 ){

                let max = (this.pages < 5) ? this.pages : 5;

                for( let i = 1; i <= max; i++ ) { buttons.push(i); }
                if ( this.pages > 6 ) { buttons.push('.'); }
            }
            else {
                buttons.push(1);
                buttons.push('.');
            }

            if ( this.current >= 5 ) {

                if ( this.current >= this.pages - 4 ) {

                    for( let i = ( this.pages - 4 ); i <= this.pages; i++ ) {
                        buttons.push(i);
                    }
                }
                else {
                    buttons.push(this.current - 1);
                    buttons.push(this.current);
                    buttons.push(this.current + 1);
                    buttons.push('.');
                    buttons.push(this.pages);
                }
            }
            else if ( this.pages > 5 ) {
                buttons.push(this.pages);
            }

            return buttons;
        }
    }
}
</script>
